import { EEthereumNetworkId } from '@ankr.com/provider';

export function isEstimateFee(chainId: EEthereumNetworkId): boolean {
  return [EEthereumNetworkId.polygon, EEthereumNetworkId.mumbai].includes(
    chainId,
  );
}
